<div class="wrapper mb-5">
    <app-grupo-create-timeline [step]="step"></app-grupo-create-timeline>
    <div class="alert alert-light my-4" role="alert">
        <!-- <h4 class="alert-heading">Vamos começar?</h4> -->
        <p>Aqui vamos selecionar alguns produtos. Escolha quais deles irão fazer parte desta cesta de benefícios. Por padrão, o benefício flexível "saldo livre" já está selecionado pois ele é obrigatório, portanto você deve escolher pelo menos mais 1 produto para poder compor a cesta de benefícios deste grupo. Apenas produtos tradicionais podem ser adicionados em um grupo flex.</p>
    </div>
    <div class="form-card mt-5">
        <span class="subtitle">Selecione os produtos que estarão disponíveis para esse grupo</span>
        <div class="row mt-4">
            <div *ngFor="let item of contractAssignor">
                <div (click)="activate(item)" class="product-card-active" *ngIf="item.selected">
                    <div class="col-5 product-select">
                        <div class="product-checkbox">
                        </div>
                        <span class="">Selecionado</span>
                    </div>
                    <div class="col-7 product-icon">
                        <img [src]="item.productEligibility.product.iconeProduto ? item.productEligibility.product.iconeProduto : 'https://seuvale-imagens-fixas.s3-sa-east-1.amazonaws.com/Icones-beneficios/SEMIMAGEM.svg'">
                        <span>{{item.productEligibility.product.descricaoProduto}}</span>
                    </div>
                </div>
                <div (click)="activate(item)" class="product-card-inactive" *ngIf="!item.selected">
                    <div class="col-5 product-select">
                        <div class="product-checkbox">
                        </div>
                        <span class="">Selecionado</span>
                    </div>
                    <div class="col-7 product-icon">
                        <img [src]="item.productEligibility.product.iconeProduto ? item.productEligibility.product.iconeProduto : 'https://seuvale-imagens-fixas.s3-sa-east-1.amazonaws.com/Icones-beneficios/SEMIMAGEM.svg'">
                        <span>{{item.productEligibility.product.descricaoProduto}}</span>
                    </div>
                </div>
            </div>
        </div>
        <button (click)="next()" class="action-button mt-5">Próximo</button>
    </div>
</div>
